import type { Vendor } from '@/types/vendor'

/** Grid columns edited through the vendor picker. */
export const VENDOR_PICKER_COLUMN_IDS = new Set(['vendor_code', 'vendor_name'])

/**
 * Cells patched when a vendor is picked (or cleared). ``vendor_id`` is the
 * hidden join key against the vendors table; code and name are what users see.
 */
export function vendorCellUpdates(
  vendor: Vendor | null
): Array<{ columnId: string; value: unknown }> {
  return [
    { columnId: 'vendor_id', value: vendor?.id ?? null },
    { columnId: 'vendor_code', value: vendor?.vendor_code ?? null },
    { columnId: 'vendor_name', value: vendor?.name ?? null },
  ]
}
